import React, { useState, useEffect } from 'react';
import Chip from '@mui/material/Chip';
import CircularProgress from "@mui/material/CircularProgress";
import {
    ExpandCircleDown,
    ExpandLess,
    CheckCircle,
    ErrorOutline,
    Error
} from "@mui/icons-material";
import {JSONComponent} from "./JSONComponent.js";
import {errorColor} from "../App/theme.js";
import {approximateTokenSize} from "../Chat/utils";
import {MESSAGE} from "../App/constants";

const APIResponseComponent = (props) => {
    // const hasYoutubeLink = props?.JSONData?.length > 0 && props?.JSONData?.find?.(o => o?.link?.startsWith?.('https://www.youtube.com/'))
    const [open, setOpen] = useState(props?.open);
    const [hidden, setHidden] = useState(!!props.showAfter);
    let entityName = props?.entityName || 'Task Completed';

    useEffect(() => {
        if (props.showAfter) {
            const timer = setTimeout(() => {
                setHidden(false);
            }, parseInt(props.showAfter));
            return () => clearTimeout(timer);
        }
    }, []);

    if (!Object.keys(props?.JSONData)?.length && !Array.isArray(props?.JSONData)) return null;

    let label = open ? entityName + ": Hide" : entityName + ": View";

    label += parseInt(props?.JSONData?.length) > 0 ? ' ' + props?.JSONData?.length + ' Results' : ' Details'

    if (props?.showResponseSize) {
        const totalTokens = approximateTokenSize(JSON.stringify(props?.JSONData));
        const isLarge = totalTokens > 10000;
        label = <p style={{ color: isLarge ? errorColor : undefined }}>
            {open ? `${isLarge ? 'Large ' : ''}Response: Hide` : `${isLarge ? 'Large ' : ''}Response: ` + ' ~ ' + totalTokens + ' tokens'}
        </p>;
    }

    if (props.loading) {
        label = "Loading ..."
    }

    const failed = props?.JSONData?.error || props?.JSONData?.data === null || props?.JSONData?.type === MESSAGE.JOB_FAILED

    if (failed) {
        entityName = props?.entityName || 'Task Failed';
        label = <p style={{ color: errorColor }}>{open ? entityName + ": Hide Details" : entityName + ": View Details"}</p>;
    }

    if (hidden) return null;

    const validJSON = typeof props?.JSONData === 'string' ? {string: props?.JSONData} : props?.JSONData;

    return (
        <>
            {<Chip
                sx={{mt: '10px'}} // to avoid overlapping with the message time
                label={label}
                onClick={() => setOpen(!open)}
                onDelete={() => setOpen(!open)}
                deleteIcon={open ? <ExpandLess /> : <ExpandCircleDown /> }
                avatar={failed
                    ? (props?.JSONData?.type === MESSAGE.JOB_FAILED ? <Error style={{ color: errorColor }} /> : <ErrorOutline style={{ color: errorColor }} />)
                    : ( props.loading ? <CircularProgress size={20} />  : <CheckCircle style={{ color: props.color }} />)
                }
            />}



            {<div style={{
                overflow: 'hidden',
                transition: 'opacity 0.3s ease-out',
                opacity: open ? '1' : '0',
                marginTop: '20px'
            }}>
                {open && <JSONComponent  data={validJSON} collapsed={!open} props={{displayObjectSize: false, displayDataTypes: false}}/>}
            </div>}
        </>
    )
}

export default APIResponseComponent;